import { Component, inject, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { appState } from '../../interfaces/appState.interface';
import { Observable } from 'rxjs';
import { selectLastUpdate, selectLastUpdateHasError } from 'src/app/redux/selectors/options.selector';

@Component({
  selector: 'app-last-update',
  templateUrl: './last-update.component.html',
  styleUrls: ['./last-update.component.scss']
})
export class LastUpdateComponent {
  private store = inject(Store<appState>);
  public lastUpdate$: Observable<Date | null> = this.store.select(selectLastUpdate);
  public hasLastUpdateError$: Observable<boolean> = this.store.select(selectLastUpdateHasError);
}
